import retryClient from './client/retryClient'
type Method = 'GET' | 'POST' | 'PUT' | 'DELETE'
import { BaseUrl } from './base_url_enum'
import { getBaseUrl } from './utils/get_base_url'

const Api = async <T, B = Record<string, unknown>>(
  method: Method,
  url: string,
  api: BaseUrl,
  params?: B
): Promise<T> => {
  const { data } = await retryClient(url, {
    baseURL: getBaseUrl(api),
    method,
    ...(method === 'GET' ? { params } : { data: params }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })

  return data
}

export default Api
